import { assert } from "@tldraw/utils";
function defineShape(type, opts) {
  assert(
    type === opts.util.type,
    `Shape type "${type}" does not match util type "${opts.util.type}"`
  );
  return { type, ...opts };
}
export {
  defineShape
};
//# sourceMappingURL=defineShape.mjs.map
